<template>
  <PageWrapper
    :isLoading="isLoading"
    is-dense
    :hasFilters="$can('GetAll', 'Users')"
    @submitFilters="getAllAbsenceReportList"
  >
    <template #title> لیست غیبت های گزارش شده </template>
    <template #filters v-if="$can('GetAll', 'Users')">
      <StudentPicker
        @getStudentUserId="setStudentUserId"
        class="w-24 filters-width"
      ></StudentPicker>
      <MasterPicker
        @getMaster="setMasterUserId"
        class="w-24 filters-width"
      ></MasterPicker>
    </template>
    <CustomTable
      v-if="absenceReports"
      :pageNumber="absenceReportsListFilters.pageNumber"
      :count="absenceReportsListFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="absenceReports"
      @changePage="changePage"
    >
      <template #masterName="data">
        <b-link :to="`/users/${data.item.masterUserId}`">
          {{ data.item.masterName }}
        </b-link>
      </template>
      <template #studentName="data">
        <b-link :to="`/users/${data.item.studentUserId}`">
          {{ data.item.studentName }}
        </b-link>
      </template>
      <template #startDate="data">
        {{ createLocaleDateTimeForSchedule(data.item) }}
      </template>
      <template #isPayBack="data">
        <BBadge :variant="data.item.isPayBack ? 'success' : 'danger'">
          {{ data.item.isPayBack ? "پرداخت شده" : "در انتظار بررسی" }}
        </BBadge>
      </template>
      <template #actions="data">
        <BButton
          variant="transparent"
          @click="renderConfirmAbsenceReportConfirmationDialog(data.item)"
        >
          <FeatherIcon size="20" icon="CheckIcon" class="text-success" />
        </BButton>
      </template>
    </CustomTable>
    <ConfirmAbsenceReportConfirmationModal
      :isOkButtonDisabled="isOkButtonDisabled"
      @sendAbsenceReportConfirmRequest="sendAbsenceReportConfirmRequest"
    ></ConfirmAbsenceReportConfirmationModal>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    isForMaster: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getAllAbsenceReportList();
  },
  data() {
    return {
      absenceReports: null,
      totalCount: null,
      absenceReportsListFilters: {
        pageNumber: 1,
        count: 10,
        studentUserId: null,
        masterUserId: null,
      },
      isOkButtonDisabled: false,
      isLoading: false,
      tempSelectedAbsence: null,
      tableColumns: [
        {
          key: "masterName",
          label: "نام استاد",
        },
        {
          key: "studentName",
          label: "نام زبان آموز",
        },
        {
          key: "startDate",
          label: "تاریخ جلسه",
        },
        {
          key: "isPayBack",
          label: "وضعیت",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    renderConfirmAbsenceReportConfirmationDialog(absenceItem) {
      this.tempSelectedAbsence = absenceItem;
      this.$bvModal.show("confirm-absence-report-by-master");
    },
    createLocaleDateTimeForSchedule(schedule) {
      return `${new Date(schedule.startDate).toLocaleDateString(
        "fa-IR"
      )} - ${new Date(schedule.startDate).toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
      })} - ${new Date(schedule.endDate).toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    },
    setMasterUserId(master) {
      this.absenceReportsListFilters.masterUserId = master
        ? master.userId
        : null;
    },
    setStudentUserId(studentUserId) {
      this.absenceReportsListFilters.studentUserId = studentUserId;
    },
    changePage(pageNumber) {
      this.absenceReportsListFilters.pageNumber = pageNumber;
      this.getAllAbsenceReportList();
    },
    async sendAbsenceReportConfirmRequest() {
      try {
        this.isLoading = true;
        this.isOkButtonDisabled = true;
        let _this = this;
        let verifyMasterAbsenceReport = new VerifyMasterAbsenceReport(_this);
        verifyMasterAbsenceReport.setRequestParam({
          scheduleId: _this.tempSelectedAbsence.scheduleId,
        });
        await verifyMasterAbsenceReport.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تایید شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "غیبت در کلاس با موفقیت تایید شد.",
              },
            });

            _this.$bvModal.hide("confirm-absence-report-by-master");
            _this.tempSelectedAbsence = null;
            _this.getAllAbsenceReportList();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تایید نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
        this.isLoading = false;
      }
    },
    async getAllAbsenceReportList() {
      try {
        this.isLoading = true;
        if (this.isForMaster) {
          this.absenceReportsListFilters.masterUserId =
            getUserData().user.userId;
        }
        let _this = this;
        let getStudentAbsenceReports = new GetStudentAbsenceReports(_this);
        getStudentAbsenceReports.setRequestParam(
          _this.absenceReportsListFilters
        );
        await getStudentAbsenceReports.fetch((res) => {
          _this.absenceReports = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BLink,
    BBadge,
    BButton,
    PageWrapper,
    SearchInput,
    CustomTable,
    StudentPicker,
    MasterPicker,
    ConfirmAbsenceReportConfirmationModal,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import StudentPicker from "@/views/components/Students/StudentPicker.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import ConfirmAbsenceReportConfirmationModal from "@/views/components/Schedule/ConfirmAbsenceReportConfirmationModal.vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  GetStudentAbsenceReports,
  VerifyMasterAbsenceReport,
} from "@/libs/Api/Schedules";
import { getUserData } from "@/auth/utils";
import { BBadge, BButton, BLink } from "bootstrap-vue";
</script>
